import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';


import { MaintenanceComponent } from 'app/core/pages/maintenance/maintenance.component';

const routes = [
    {
        path     : 'maintenance',
        component: MaintenanceComponent
    }
];

@NgModule({
    declarations: [
        MaintenanceComponent
    ],
    imports     : [
        RouterModule.forChild(routes)
    ]
})
export class MaintenanceModule
{
}
